import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";
import PurchaseEntry from "./Purchase Entry/PurchaseEntry";
import PurchaseRecord from "./PurchaseRecord";
import PurchaseVoucher from "./PurchaseVoucher";
import Suppliers from "./Supplier Entry/Suppliers";
import { useLocation } from "react-router-dom";
import { accessChecker } from "../../../lib/functions";
import SSCCAggregation from "../../Tatmeen/SSCCAggregation/SSCCAggregation";
import CuttingLogic from "../CuttingLogic/CuttingLogic";

const Purchase = ({ authInfo }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Purchase Entry",
      key: "entry",
      value: "purchase_entry",
      children: (
        <>
          <PurchaseEntry />
        </>
      ),
    },
    {
      label: "SSCCAggregation Entry",
      key: "sscc",
      value: "tatmeen_entry",
      children: (
        <>
          <SSCCAggregation />
        </>
      ),
    },
    {
      label: "Supplier Entry",
      key: "sentry",
      value: "supplier_entry",
      children: (
        <>
          <Suppliers />
        </>
      ),
    },
    {
      label: "Parsing Logic",
      key: "cutting-logic",
      value: "purchase_entry",
      children: (
        <>
          <CuttingLogic />
        </>
      ),
    },
    {
      label: "Purchase Record",
      key: "record",
      value: "purchase_record",
      children: (
        <>
          <PurchaseRecord />
        </>
      ),
    },
    {
      label: "Purchase Voucher",
      key: "voucher",
      value: "purchase_voucher",
      children: (
        <>
          <PurchaseVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));
  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default Purchase;
